import React, { Component } from 'react';
import {
    Grid, Row, Col
} from 'react-bootstrap';

import Card from 'components/Card/Card.jsx';
import FormInputs from 'components/FormInputs/FormInputs.jsx';
import UserCard from 'components/Card/UserCard.jsx';
import Button from 'elements/CustomButton/CustomButton.jsx';
import { Authenticator } from 'services/AuthService.jsx'
import NotificationSystem from 'react-notification-system';
import { style } from "variables/Variables.jsx";

class UserPage extends Component {
  constructor(props){
    super(props);
    this.state = { user: {
        email: "",
        avatar: "https://storage.googleapis.com/devgekko-test/avatar/default_avatar.png",
        name: "",
        company: "",
        password: "",
        passwordRepeat: ""
      },
      _notificationSystem: null
    };
    this.handleNotification = this.handleNotification.bind(this);
  }
  componentDidMount(props) {
    Authenticator.getUser((user) => {
      this.setState({user: user});
    });
    this.setState({_notificationSystem: this.refs.notificationSystem});
  }
  handleNotification(message, level) {
    this.state._notificationSystem.addNotification({
        title: (<span data-notify="icon" className="pe-7s-attention"></span>),
        message: (
            <div>
                {message}
            </div>
        ),
        level: level,
        position: 'tc',
        autoDismiss: 3,
        dismissible: false
    });
  }
  handleChange(e) {
    const new_user = this.state.user;
    new_user[e.target.name] = e.target.value;
    this.setState({ user: new_user, _notificationSystem: this.state._notificationSystem });
  }
  updateProfile(e) {
    e.preventDefault();
    Authenticator.update(this.state.user, (response) => {
      if (response.success) {
        this.handleNotification("User profile updated!", 'success');
      } else {
        response.errors.forEach((element) => {
          this.handleNotification(element, 'warning');
        });
      }
    });
  }
    render() {
        return (
            <div className="main-content">
              <NotificationSystem ref="notificationSystem" style={style}/>
                <Grid fluid>
                    <Row>
                        <Col md={8}>
                            <Card
                                title="Edit Profile"
                                content={
                                    <form onSubmit={this.updateProfile.bind(this)}>
                                        <FormInputs
                                            ncols = {["col-md-12"]}
                                            proprieties = {[
                                                {
                                                 label : "Name",
                                                 type : "text",
                                                 bsClass : "form-control",
                                                 placeholder : "Name",
                                                 value : this.state.user.name,
                                                 name : "name",
                                                 onChange : this.handleChange.bind(this)
                                                }
                                            ]}
                                        />
                                        <FormInputs
                                            ncols = {["col-md-12"]}
                                            proprieties = {[
                                                {
                                                 label : "Company",
                                                 type : "text",
                                                 bsClass : "form-control",
                                                 placeholder : "Company",
                                                 value : this.state.user.company,
                                                 name : "company",
                                                 onChange : this.handleChange.bind(this)
                                                }
                                            ]}
                                        />
                                        <FormInputs
                                            ncols = {["col-md-12"]}
                                            proprieties = {[
                                              {
                                               label : "Email address",
                                               type : "email",
                                               bsClass : "form-control",
                                               placeholder : "Email",
                                               disabled: true,
                                               value : this.state.user.email,
                                               name : "email",
                                               onChange : this.handleChange.bind(this)
                                              }
                                            ]}
                                        />
                                        <FormInputs
                                            ncols = {["col-md-12"]}
                                            proprieties = {[
                                              {
                                               label : "New Password",
                                               type : "password",
                                               bsClass : "form-control",
                                               placeholder : "Password",
                                               name : "password",
                                               onChange : this.handleChange.bind(this)
                                              }
                                            ]}
                                        />
                                        <FormInputs
                                            ncols = {["col-md-12"]}
                                            proprieties = {[
                                              {
                                               label : "Repeat Password",
                                               type : "password",
                                               bsClass : "form-control",
                                               placeholder : "Repeat Password",
                                               name : "passwordRepeat",
                                               onChange : this.handleChange.bind(this)
                                              }
                                            ]}
                                        />
                                        <Button
                                            bsStyle="info"
                                            pullRight
                                            fill
                                            type="submit"
                                        >
                                            Update Profile
                                        </Button>
                                        <div className="clearfix"></div>
                                    </form>
                                }
                            />
                        </Col>
                        <Col md={4}>
                            <UserCard
                                bgImage="https://ununsplash.imgix.net/photo-1431578500526-4d9613015464?fit=crop&fm=jpg&h=300&q=75&w=400"
                                avatar={this.state.user.avatar}
                                name={this.state.user.name}
                                userName={this.state.user.email}
                            />

                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

export default UserPage;



// WEBPACK FOOTER //
// ./src/views/Pages/UserPage.jsx